import { useLegacyAllCommonTermsForProducts } from './useBulkPurchaseOptions';
import { useAppSelector } from '../reducers';
import { hasProductLevelOrHigherInProductInventorySelector } from '../selectors/ProductInventorySelectors';

/**
 * @deprecated Temporary workaround for PPUIv1 - DO NOT USE OR COPY THIS IN PPUI V2
 * @description This hook is used to determine if the term toggle can be shown on a product merch card.
 *
 * @example
 * const shouldShowTermToggle = useShouldShowTermToggleForMerchCard(product);
 *
 * @returns A boolean indicating if the term toggle should be shown for the merch card.
 */
export const useShouldShowTermToggleForMerchCard = product => {
  const {
    commonTerms
  } = useLegacyAllCommonTermsForProducts({
    apiNames: product !== null && product !== void 0 && product.apiName ? [product.apiName] : undefined
  });
  const hasTwoTerms = commonTerms.length > 1;
  const ownsProductOrHigher = useAppSelector(state => product ? hasProductLevelOrHigherInProductInventorySelector(state, {
    productLine: product.productLine,
    productLevel: product.productLevel
  }) : false);
  return hasTwoTerms && !ownsProductOrHigher;
};